import { BaseAPI } from "./BaseAPI";

import type { APIConf } from "./BaseAPI";
import type {
  GetBulkJsonParams,
  GetBulkJsonResponse,
  GetBulkReportParams,
  GetBulkStatusParams,
  GetBulkStatusResponse,
  GetIndexBulkListParams,
  GetIndexBulkListResponse,
  RunBulkIngestParams,
  RunBulkIngestResponse,
  SetBulkStorefrontProjectParams,
  SetBulkStorefrontProjectResponse,
  UploadBulkParams,
  UploadBulkResponse,
} from "./BulkAPI.types";

class BulkAPIClass extends BaseAPI {
  constructor(conf: APIConf) {
    super(conf);
    this.service = "bulk";
    this.version = "v1";
  }

  async getIndexBulkList({
    page = 1,
    perPage = 10,
    search,
    status,
    order,
  }: GetIndexBulkListParams = {}): Promise<GetIndexBulkListResponse> {
    return this.axios
      .get<GetIndexBulkListResponse>(`${this.routeBase}/index`, {
        params: {
          page,
          per_page: perPage,
          search: search ?? null,
          status: status?.length ? status.join(",") : null,
          ...(order ? { column: order.field, direction: order.direction } : {}),
        },
      })
      .then((response) => response.data);
  }

  async getBulkStatus({
    bulkId,
  }: GetBulkStatusParams): Promise<GetBulkStatusResponse> {
    return this.axios
      .get<GetBulkStatusResponse>(`${this.routeBase}/status/${bulkId}`)
      .then((response) => response.data);
  }

  async uploadBulk({
    file,
    onUploadProgress,
  }: UploadBulkParams): Promise<UploadBulkResponse> {
    const params = {
      file: file.base64,
      filename: file.name,
    };
    return this.axios
      .post<UploadBulkResponse>(`${this.routeBase}/new`, params, {
        onUploadProgress,
      })
      .then((response) => response.data);
  }

  async setBulkStorefrontProject({
    bulkId,
    sfpUuid,
  }: SetBulkStorefrontProjectParams): Promise<SetBulkStorefrontProjectResponse> {
    return this.axios
      .put<SetBulkStorefrontProjectResponse>(`${this.routeBase}/${bulkId}`, {
        sfp_uuid: sfpUuid,
      })
      .then((response) => response.data);
  }

  async runBulkIngest({
    bulkId,
  }: RunBulkIngestParams): Promise<RunBulkIngestResponse> {
    return this.axios
      .post<RunBulkIngestResponse>(`${this.routeBase}/run/${bulkId}`)
      .then((response) => response.data);
  }

  async getBulkReport({ bulkId }: GetBulkReportParams): Promise<string> {
    return this.axios
      .get<string>(`${this.routeBase}/export/${bulkId}`)
      .then((response) => response.data);
  }

  async getBulkJson({
    bulkId,
  }: GetBulkJsonParams): Promise<GetBulkJsonResponse> {
    return this.axios
      .get<GetBulkJsonResponse>(`${this.routeBase}/export/media/${bulkId}`)
      .then((response) => response.data);
  }
}

const BulkAPI = new BulkAPIClass({
  token: localStorage.token,
});

export default BulkAPI;
